'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Streamline your business application with the best MEAN Stack development services!"
                alt="MEAN Stack Development"
                title="MEAN Stack Development"
                width={1090}
                height={604}
                path={'meanstack-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                MEAN Stack <div>Development Company</div>
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="MEAN Stack" />
            <ContetVideoSection title="Empower Your Application's Efficiency with Power-Packed, Open-Source, and Advanced MEAN Stack Technologies">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Ensuring rapidity, efficiency, and scalability, MEAN Stack- a JavaScript-based technology platform is
                        widely approached to build dynamic, scalable, and feature-rich applications. Compiled with four advanced
                        and modern JavaScript-based technologies MongoDB, Express.js, Angular.js, and Node.js, it is widely used
                        in front-end as well as back-end development. The structure with a combination of MongoDB- A NoSQL
                        database leveraging flexible storage layers, Express JS- standardized web app development, Angular.Js -
                        allows smooth and flawless front-end interactions, and Node.js - that don`&#39;t let your server go down,
                        together with forms the MEAN Stack anatomy. The structure of MEAN Stack is more suitable for maintaining
                        the dynamic structure of a website and mobile applications.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">So, what are you waiting for?</p>
                </>
            </ContetVideoSection>
            <HireProcess
                bg="bg-meanstack"
                pageTitle="Hire Our Expert MEAN Stack Developers For Your Next Project"
                desc="We boast experienced MEAN stack developers to build highly agile, scalable, and feature-rich software solutions for any business."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For MEAN Stack Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best MEAN Stack Developers"
                desc="We have one of the finest MEAN Stack app developer teams that strive hard to serve your modern tech-savvy requirements with hands-on industrial knowledge accompanied by the latest tools and techniques. So, if you’re looking to hire MEAN Stack app developers to satisfy your business needs cost-effectively and robustly, Moweb is the best MEAN Stack app development company to meet your business goals and objectives. Contact us now to hire MEAN Stack developers from us as per the below model."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
